// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DesignPackageConfigurator_DesignPackage_VersionsFragmentDoc } from '../DesignPackageConfigurator.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DesignPackageSlotsQueryVariables = Types.Exact<{
  dpId: Types.Scalars['ID']['input'];
  rpavId: Types.Scalars['ID']['input'];
}>;


export type DesignPackageSlotsQuery = { __typename?: 'Query', designPackage: { __typename?: 'DesignPackage', id: string, copyInProgress: boolean, cloneInProgress: boolean, slots: Array<{ __typename?: 'DesignPackageSlot', id: string, coverage: number, isFullyAssigned: boolean, pendingDeletion: boolean, hasPendingPlanPackageIncomingSlots: boolean, slot: { __typename?: 'ItemSlot', id: string, name: string, location: { __typename?: 'Location', id: string, displayLocationPath: string, nonScopeLocation: { __typename?: 'Location', id: string, name: string }, roomType?: { __typename?: 'RoomType', id: string, name: string, canDesignPackageRemap?: boolean | null | undefined } | null | undefined }, item: { __typename?: 'Item', id: string, name: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, name: string } } }, items: Array<{ __typename?: 'TakeoffLineItem', id: string }> }>, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, displayVersion: string, updatedAt: Types.Scalars['DateTime']['input'], status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus, name: string } }> } };

export type CreateAlternateLocationMutationVariables = Types.Exact<{
  input: Types.CreateDesignPackageAlternateLocationInput;
}>;


export type CreateAlternateLocationMutation = { __typename?: 'Mutation', createDesignPackageAlternateLocation: { __typename?: 'CreateDesignPackageAlternateLocationResult', readyPlanLocation: { __typename?: 'ReadyPlanLocation', id: string } } };

export type CancelPlanPackageSlotDeletionMutationVariables = Types.Exact<{
  input: Types.CancelPlanPackageSlotDeletionInput;
}>;


export type CancelPlanPackageSlotDeletionMutation = { __typename?: 'Mutation', cancelPlanPackageSlotDeletion: { __typename: 'EmptyResult' } };

export type DesignPackageLeftNavSlotFragment = { __typename?: 'DesignPackageSlot', id: string, coverage: number, isFullyAssigned: boolean, pendingDeletion: boolean, hasPendingPlanPackageIncomingSlots: boolean, slot: { __typename?: 'ItemSlot', id: string, name: string, location: { __typename?: 'Location', id: string, displayLocationPath: string, nonScopeLocation: { __typename?: 'Location', id: string, name: string }, roomType?: { __typename?: 'RoomType', id: string, name: string, canDesignPackageRemap?: boolean | null | undefined } | null | undefined }, item: { __typename?: 'Item', id: string, name: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, name: string } } }, items: Array<{ __typename?: 'TakeoffLineItem', id: string }> };

export const DesignPackageLeftNavSlotFragmentDoc = gql`
    fragment DesignPackageLeftNavSlot on DesignPackageSlot {
  id
  slot {
    id
    name
    location {
      id
      displayLocationPath
      nonScopeLocation {
        id
        name
      }
      roomType {
        id
        name
        canDesignPackageRemap
      }
    }
    item {
      id
      name
      fullCode
      costCode {
        id
        name
      }
    }
  }
  coverage
  isFullyAssigned
  pendingDeletion
  hasPendingPlanPackageIncomingSlots
  items {
    id
  }
}
    `;
export const DesignPackageSlotsDocument = gql`
    query DesignPackageSlots($dpId: ID!, $rpavId: ID!) {
  designPackage(id: $dpId, versionId: $rpavId) {
    id
    copyInProgress
    cloneInProgress
    ...DesignPackageConfigurator_DesignPackage_Versions
    slots {
      ...DesignPackageLeftNavSlot
    }
  }
}
    ${DesignPackageConfigurator_DesignPackage_VersionsFragmentDoc}
${DesignPackageLeftNavSlotFragmentDoc}`;

/**
 * __useDesignPackageSlotsQuery__
 *
 * To run a query within a React component, call `useDesignPackageSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignPackageSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignPackageSlotsQuery({
 *   variables: {
 *      dpId: // value for 'dpId'
 *      rpavId: // value for 'rpavId'
 *   },
 * });
 */
export function useDesignPackageSlotsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DesignPackageSlotsQuery, DesignPackageSlotsQueryVariables> & ({ variables: DesignPackageSlotsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DesignPackageSlotsQuery, DesignPackageSlotsQueryVariables>(DesignPackageSlotsDocument, options);
      }
export function useDesignPackageSlotsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DesignPackageSlotsQuery, DesignPackageSlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DesignPackageSlotsQuery, DesignPackageSlotsQueryVariables>(DesignPackageSlotsDocument, options);
        }
// @ts-ignore
export function useDesignPackageSlotsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DesignPackageSlotsQuery, DesignPackageSlotsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DesignPackageSlotsQuery, DesignPackageSlotsQueryVariables>;
export function useDesignPackageSlotsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DesignPackageSlotsQuery, DesignPackageSlotsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DesignPackageSlotsQuery | undefined, DesignPackageSlotsQueryVariables>;
export function useDesignPackageSlotsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DesignPackageSlotsQuery, DesignPackageSlotsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DesignPackageSlotsQuery, DesignPackageSlotsQueryVariables>(DesignPackageSlotsDocument, options);
        }
export type DesignPackageSlotsQueryHookResult = ReturnType<typeof useDesignPackageSlotsQuery>;
export type DesignPackageSlotsLazyQueryHookResult = ReturnType<typeof useDesignPackageSlotsLazyQuery>;
export type DesignPackageSlotsSuspenseQueryHookResult = ReturnType<typeof useDesignPackageSlotsSuspenseQuery>;
export type DesignPackageSlotsQueryResult = Apollo.QueryResult<DesignPackageSlotsQuery, DesignPackageSlotsQueryVariables>;
export const CreateAlternateLocationDocument = gql`
    mutation CreateAlternateLocation($input: CreateDesignPackageAlternateLocationInput!) {
  createDesignPackageAlternateLocation(input: $input) {
    readyPlanLocation {
      id
    }
  }
}
    `;
export type CreateAlternateLocationMutationFn = Apollo.MutationFunction<CreateAlternateLocationMutation, CreateAlternateLocationMutationVariables>;

/**
 * __useCreateAlternateLocationMutation__
 *
 * To run a mutation, you first call `useCreateAlternateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlternateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlternateLocationMutation, { data, loading, error }] = useCreateAlternateLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAlternateLocationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAlternateLocationMutation, CreateAlternateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAlternateLocationMutation, CreateAlternateLocationMutationVariables>(CreateAlternateLocationDocument, options);
      }
export type CreateAlternateLocationMutationHookResult = ReturnType<typeof useCreateAlternateLocationMutation>;
export type CreateAlternateLocationMutationResult = Apollo.MutationResult<CreateAlternateLocationMutation>;
export type CreateAlternateLocationMutationOptions = Apollo.BaseMutationOptions<CreateAlternateLocationMutation, CreateAlternateLocationMutationVariables>;
export const CancelPlanPackageSlotDeletionDocument = gql`
    mutation CancelPlanPackageSlotDeletion($input: CancelPlanPackageSlotDeletionInput!) {
  cancelPlanPackageSlotDeletion(input: $input) {
    __typename
  }
}
    `;
export type CancelPlanPackageSlotDeletionMutationFn = Apollo.MutationFunction<CancelPlanPackageSlotDeletionMutation, CancelPlanPackageSlotDeletionMutationVariables>;

/**
 * __useCancelPlanPackageSlotDeletionMutation__
 *
 * To run a mutation, you first call `useCancelPlanPackageSlotDeletionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPlanPackageSlotDeletionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPlanPackageSlotDeletionMutation, { data, loading, error }] = useCancelPlanPackageSlotDeletionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelPlanPackageSlotDeletionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelPlanPackageSlotDeletionMutation, CancelPlanPackageSlotDeletionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelPlanPackageSlotDeletionMutation, CancelPlanPackageSlotDeletionMutationVariables>(CancelPlanPackageSlotDeletionDocument, options);
      }
export type CancelPlanPackageSlotDeletionMutationHookResult = ReturnType<typeof useCancelPlanPackageSlotDeletionMutation>;
export type CancelPlanPackageSlotDeletionMutationResult = Apollo.MutationResult<CancelPlanPackageSlotDeletionMutation>;
export type CancelPlanPackageSlotDeletionMutationOptions = Apollo.BaseMutationOptions<CancelPlanPackageSlotDeletionMutation, CancelPlanPackageSlotDeletionMutationVariables>;